import type { DiscountListItem } from 'src/app/pages/marketing/discounts/wizard-refactor/models';

export function calculateMaxMenuRank(ecommDiscounts: DiscountListItem[]): number {
  const result = ecommDiscounts.reduce<Pick<DiscountListItem, 'MenuDisplayRank'>>(
    (a, b) => ({
      MenuDisplayRank: Math.max(a.MenuDisplayRank ?? -1, b.MenuDisplayRank ?? -1),
    }),
    { MenuDisplayRank: -Infinity }
  );
  let maxRank = result.MenuDisplayRank as number;
  if (Number.isNaN(maxRank) || maxRank === -Infinity) {
    maxRank = -1; // If all ranks are null, set max to -1 so when we increment it when populating ranks, it becomes 0
  }
  return maxRank;
}
